const listings = {
  hero: {
    title:     "Объявления",
    sub_one:   "{{count}} объект доступен по всем Эмиратам",
    sub_few:   "{{count}} объекта доступны по всем Эмиратам",
    sub_many:  "{{count}} объектов доступно по всем Эмиратам",
    sub_other: "{{count}} объектов доступно по всем Эмиратам",
  },
  filters: {
    label:    "Фильтры",
    reset:    "Сбросить",
    status:   "Статус",
    all:      "Все",
    sale:     "Продажа",
    rent:     "Аренда",
    type:     "Тип",
    typeAll:  "Все типы",
    emirates: "Эмират",
    any:      "Любой",
    beds:     "Спальни",
    maxPrice: "Макс. цена (AED)",
  },
  results: {
    count_one:   "{{count}} объект",
    count_few:   "{{count}} объекта",
    count_many:  "{{count}} объектов",
    count_other: "{{count}} объектов",
    sort:        "Сортировка:",
    sortDefault: "По умолчанию",
    sortAsc:     "Цена: по возрастанию",
    sortDesc:    "Цена: по убыванию",
    noResults:   "Объекты по вашим фильтрам не найдены.",
    clearFilters:"Сбросить фильтры",
  },
};

export default listings;
